module.exports = "/fonts/gt-walsheim-ultra-bold.ttf";